import styled from '@emotion/styled';
import { AnimatedPlaceholder } from '../../styled';

export const WorklogItemPlaceholder = styled.div`
  display: flex;
  padding-top: 4px;
  border-radius: 4px;
`;
export const Columns = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 10px 0 5px;
`;
export const Avatar = styled(AnimatedPlaceholder)`
  border-radius: 32px;
  width: 32px !important;
  height: 32px !important;
  background: #fff;
  margin: 2px 0 2px 2px;
  flex: 0 0 auto;
`;
export const Title = styled(AnimatedPlaceholder)`
  width: 300px !important;
  height: 18px !important;
  line-height: 20px;
  border-radius: 50px;
`;
export const Footer = styled(AnimatedPlaceholder)`
  width: 100px !important;
  height: 14px !important;
  margin-top: 5px;
  line-height: 20px;
  border-radius: 50px;
`;
export const CardName = styled(AnimatedPlaceholder)`
  width: 200px !important;
  height: 14px !important;
  margin-top: 5px;
  line-height: 20px;
  border-radius: 50px;
`;
export const Divider = styled.hr`
  margin: 10px 0 0;
  width: 100%;
  background-color: ${({ theme }) =>
    theme.dark ? '#A6C5E229' : 'rgba(9, 30, 66, 0.13)'};
`;
